import { SET_PAGE_CONTENT_DYNAMIC_VALUES } from 'constants/reduxActions';

export function setPageContentDynamicValues(dynamicValues) {
  return {
    type: SET_PAGE_CONTENT_DYNAMIC_VALUES,
    dynamicValues
  };
}
